<template>
  <el-aside
    class="aside"
    :class="{ 'hide-settings': !this.$store.state.echart.settingShowFlag }"
  >
    <div class="settings-main">
      <el-row>
        <el-col :span="16" class="setting-title"> 個人設定 </el-col>
        <el-col :span="4">
          <el-button
            type="info"
            icon="el-icon-save"
            circle
            class="setting-save"
          :disabled="this.$store.state.sysInit.personalEnable == 0 ||
              this.$store.state.stt.isMicOn||
              this.$store.state.sysInit.manualChatUserCount > 0"
            @click="saveSettig"
          ></el-button>
        </el-col>
        <el-col :span="4">
          <el-button
            type="danger"
            icon="el-icon-close"
            circle
            class="setting-close"
            @click="closeSetting"
          ></el-button>
        </el-col>
        </el-row>
      <el-row class="vertical-space">
       <el-col :span="8" class="setting-title" style="padding-bottom:10px"> アイコン画像</el-col>
       <el-col :span="18" >
  <div class="setting-image">
    <span v-if="!this.isUpload">
<img v-if="this.$store.state.sysInit.ws_mode != 'STAND_MIC_MODE'" :src="this.$store.state.sysInit.operator_logo"  class="user_logo" />
<img v-else :src="this.$store.state.sysInit.operator_logo_f2f"  class="user_logo"/>
    </span>
    <span v-else>
<img :src="this.logo_img_url"  class="user_logo"/>
    </span>

          <el-upload
          :limit="1"
          ref="imageUpload"
          action=""
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          :on-change="handleChange"
          :auto-upload="false">

          <el-button slot="trigger" size="small" type="primary" style="height: 35px; background-color:#0070C0;border-radius: 5px;color:#ecf5ff">画像をアップロード</el-button>
          <!-- <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传到服务器</el-button> -->
          <!-- <div slot="tip" class="el-upload__tip">Operator upload</div> -->
        </el-upload>
       </div>

       </el-col>

      </el-row>

      <el-row class="vertical-space">
        <el-col :span="24" class="setting-title" > 音声接続モード</el-col>
        <el-col
          :span="20"
          class="setting-mode"
          :class="{
            'setting-disbled':
              this.$store.state.sysInit.personalEnable == 0 ||
              this.$store.state.stt.isMicOn||
              this.$store.state.sysInit.manualChatUserCount > 0
          }"
        >
          <el-dropdown
            @command="saveVoiceConnectionMode"
            size="medium"
            style="width: 100%"
          >
            <div class="el-dropdown-link">
              {{
                this.$store.state.sysInit.temp_VoiceConnectionMode ==
                "NEXMO_ASTERISK_PBX_MODE"
                  ? "電話モード"
                  : this.$store.state.sysInit.temp_VoiceConnectionMode ==
                    "MANUAL_CHAT_MODE"
                  ? "チャットモード"
                  : "F2Fモード"
              }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="item in voiceConnectionModes"
                :key="item"
                :command="item"
                >{{ item }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </el-col>
        <el-col class="setting-desc">
          電話応対時に使用する接続モードです。
        </el-col>
      </el-row>

      <el-row class="vertical-space">
        <el-col :span="24" class="setting-title"> 音声変換モード</el-col>
        <el-col :span="20" class="setting-mode">
          <el-dropdown
            @command="saveVoiceConvertMode"
            size="medium"
            style="width: 100%"
          >
            <div class="el-dropdown-link">
              {{
                this.$store.state.sysInit.temp_VoiceConvertMode
                  ? this.$store.state.sysInit.html_const
                      .cons_210_realtime_translation
                  : this.$store.state.sysInit.html_const
                      .cons_211_per_sentence_translation
              }}

              <i class="el-icon-arrow-down el-icon--right"></i>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="item in voiceConvertModes"
                :key="item"
                :command="item"
                >{{ item }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </el-col>
        <el-col class="setting-desc">
          音声テキスト変換結果がリアルタイムに表示されます。
        </el-col>
      </el-row>

      <el-row class="vertical-space">
        <el-col :span="24" class="setting-title"> ノイズキャンセリング </el-col>
        <el-col class="setting-desc">
          ノイズキャンセルの強さを設定します。<br />（0〜100）
        </el-col>
        <el-col :span="24">
          <el-col class="vertical-space"> 自分の音</el-col>
          <el-col :span="19">
            <el-slider v-model="noiseCancelSpeech"></el-slider>
          </el-col>
          <el-col :span="5">
            <el-input
              class="setting-voice"
              v-model="noiseCancelSpeech"
              placeholder=""
            ></el-input>
          </el-col>
        </el-col>
      </el-row>

      <el-row class="vertical-space">
        <el-col :span="24">
          <el-col> 周囲の音</el-col>
          <el-col :span="19">
            <el-slider v-model="noiseCancelBk"></el-slider>
          </el-col>
          <el-col :span="5">
            <el-input
              class="setting-voice"
              v-model="noiseCancelBk"
              placeholder=""
            ></el-input>
          </el-col>
        </el-col>
      </el-row>
    </div>
  </el-aside>
</template>

<script>
import { mapGetters, mapMutations, mapState } from "vuex";
import api from "@/api";
import { Message } from "element-ui";
export default {
  components: {},
  props: {},
  data() {
    return {
      voiceConnectionModes: ["電話モード", "F2Fモード", "チャットモード"],
      voiceConvertModes: ["随時変換モード", "一文確定モード"],
      noiseCancelSpeech: this.$store.state.sysInit.noiseCancelSpeech,
      noiseCancelBk: this.$store.state.sysInit.noiseCancelBk,
      // ConnectionMode:"",
      // ConvertMode:"",
      file: "",
      logo_img_url:"",
      isUpload:false,

    };
  },
  watch: {},
  computed: {},
  methods: {
    saveVoiceConnectionMode(command) {
      if (command == "電話モード") {
        this.$store.state.sysInit.temp_VoiceConnectionMode =
          "NEXMO_ASTERISK_PBX_MODE";
      } else if (command == "F2Fモード") {
        this.$store.state.sysInit.temp_VoiceConnectionMode = "STAND_MIC_MODE";
      } else {
        this.$store.state.sysInit.temp_VoiceConnectionMode = "MANUAL_CHAT_MODE";
      }
      // this.$store.state.sysInit.temp_VoiceConnectionMode =
      //   command == "電話モード" ? "NEXMO_ASTERISK_PBX_MODE" : "STAND_MIC_MODE";
      // this.ConnectionMode =  this.$store.state.sysInit.temp_VoiceConnectionMode;
      this.$store.state.stt.wordList = [];
      console.log(this.$store.state.sysInit.temp_VoiceConnectionMode);
    },
    saveVoiceConvertMode(command) {
      // this.$store.state.sysInit.temp_VoiceConvertMode = this.$store.state.sysInit.showImmediately;
      if (command == "随時変換モード") {
        this.$store.state.sysInit.temp_VoiceConvertMode = true;
      } else {
        this.$store.state.sysInit.temp_VoiceConvertMode = false;
      }
      // this.ConvertMode = this.$store.state.sysInit.temp_VoiceConvertMode
    },
    closeSetting() {
      this.$store.commit(
        "echart/changeSettingsFlag",
        !this.$store.state.echart.settingShowFlag
      );
      this.$store.state.sysInit.temp_VoiceConnectionMode =
        this.$store.state.sysInit.personalSingleMode;
      this.$store.state.sysInit.temp_VoiceConvertMode =
        this.$store.state.sysInit.showImmediately;
    },
    saveSettig() {
      this.$emit('saveConfig')
      this.$store.commit(
          "sysInit/changeNavigationText",
          ""
        );
        this.$store.state.sysInit.isBlingFlg = false;
        this.$store.state.sysInit.isBlingFlg_call = false;

        this.$store.state.store_sv.sv_help_isBlingFlg = false;
        this.$store.state.store_sv.sv_help_onSupportFlg = false;
        this.$store.state.store_sv.isSvTalkBlingFlg = false;
        this.submitUpload();
      if (
        this.$store.state.sysInit.personalEnable == 0 ||
        this.$store.state.stt.isMicOn ||
        this.$store.state.sysInit.manualChatUserCount > 0
      ) {
        let params = {
          user_id: this.$store.state.sysInit.user_id,
          // personalSingleMode: this.$store.state.sysInit.temp_VoiceConnectionMode,
          stt_mode: this.$store.state.sysInit.temp_VoiceConvertMode ? 1 : 0,
          noise_cancel_speech: this.noiseCancelSpeech,
          noise_cancel_bk: this.noiseCancelBk,
        };

        api
          .updatePersonalConfig(params)
          .then(
            (result) => {
              console.log("setting_params", params);
              this.$store.state.sysInit.personalSingleMode =
                this.$store.state.sysInit.temp_VoiceConnectionMode;
              this.$store.state.sysInit.showImmediately =
                this.$store.state.sysInit.temp_VoiceConvertMode;
              if (
                this.$store.state.sysInit.temp_VoiceConnectionMode ===
                "NEXMO_ASTERISK_PBX_MODE"
              ) {
                this.$store.state.sysInit.modeFlag = true;
                this.$store.dispatch(
                  "sysInit/changerTurnMicStartTitle",
                  this.$store.state.sysInit.temp_VoiceConnectionMode
                );
              } else {
                this.$store.state.sysInit.modeFlag = false; ///
                this.$store.dispatch(
                  "sysInit/changerTurnMicStartTitle",
                  this.$store.state.sysInit.temp_VoiceConnectionMode
                );
              }

              if (
                this.$store.state.sysInit.temp_VoiceConnectionMode !=
                "NEXMO_ASTERISK_PBX_MODE"
              ) {
                this.$store.dispatch(
                  "sysInit/changerTurnMicStartTitle",
                  this.$store.state.sysInit.temp_VoiceConnectionMode
                );
              }

              this.$store.dispatch("sysInit/connectStatusWs");
              // if (this.$store.state.sysInit.temp_VoiceConnectionMode == "STAND_MIC_MODE") {
              //      this.$store.dispatch("sysInit/connectF2FSvSocket");
              //  }

              this.$store.dispatch("stt/changeOnCallFlag");
              this.$store.dispatch("sysInit/getSttToken");
              Message.success({
                message:
                  this.$store.state.sysInit.html_const
                    .cons_258_personal_setting,
              });
              this.$store.state.sysInit.piIssueListEmptyFlg = true;
              this.$store.state.sysInit.piCustomerInfoEmptyFlg = true;
              this.$store.state.sysInit.manualChatbotShowFlg = true;
              this.$store.state.sysInit.searchDetail_unsolvedIssueListVisible = false;
              this.$store.state.sysInit.unsolvedIssueList = [];
              this.$store.state.sysInit.searchDetail_issue_tracker = ""
              this.$store.state.sysInit.searchDetail_issue_category = ""
              //  if (this.$store.state.sysInit.temp_VoiceConnectionMode == "MANUAL_CHAT_MODE") {
              //      setTimeout(() => {
              //        window.location.reload();
              //     }, 1000);
              //  }else if(this.$store.state.sysInit.temp_VoiceConnectionMode == "NEXMO_ASTERISK_PBX_MODE"){
              //   setTimeout(() => {
              //        window.location.reload();
              //     }, 1000);
              //  }
            },
            (err) => {}
          )
          .catch((err) => {
            console.log(err);
          });
      } else {
        let params = {
          user_id: this.$store.state.sysInit.user_id,
          personalSingleMode:
            this.$store.state.sysInit.temp_VoiceConnectionMode,
          stt_mode: this.$store.state.sysInit.temp_VoiceConvertMode ? 1 : 0,
          noise_cancel_speech: this.noiseCancelSpeech,
          noise_cancel_bk: this.noiseCancelBk,
        };

        api
          .updatePersonalConfig(params)
          .then(
            (result) => {
              this.$store.state.sysInit.piEmptyFlg = true;
              console.log("setting_params", params);
              this.$store.state.sysInit.personalSingleMode =
                this.$store.state.sysInit.temp_VoiceConnectionMode;
              this.$store.state.sysInit.showImmediately =
                this.$store.state.sysInit.temp_VoiceConvertMode;
              if (
                this.$store.state.sysInit.temp_VoiceConnectionMode ===
                "NEXMO_ASTERISK_PBX_MODE"
              ) {
                this.$store.state.sysInit.modeFlag = true;
                this.$store.state.sysInit.showPiButton = "ok"; //////
                this.$store.state.sysInit.showChatPiButton = "no";
                console.log(
                  "showPiButton",
                  this.$store.state.sysInit.showPiButtonn
                );
                this.$store.dispatch(
                  "sysInit/changerTurnMicStartTitle",
                  this.$store.state.sysInit.temp_VoiceConnectionMode
                );
              } else if (
                this.$store.state.sysInit.temp_VoiceConnectionMode ===
                "MANUAL_CHAT_MODE"
              ) {
                 this.$store.state.sysInit.modeFlag = true;
                console.log(
                  "showPiButton",
                  this.$store.state.sysInit.showPiButtonn
                );
                this.$store.dispatch(
                  "sysInit/changerTurnMicStartTitle",
                  this.$store.state.sysInit.temp_VoiceConnectionMode
                );
                this.$store.state.sysInit.showChatPiButton = "ok";
                this.$store.state.sysInit.showPiButton = "no";
              } else {
                this.$store.state.sysInit.modeFlag = false; ///
                this.$store.state.sysInit.showChatPiButton = "no";
                this.$store.state.sysInit.showPiButton = "no"; /////

                console.log(
                  "showPiButton",
                  this.$store.state.sysInit.showPiButton
                );
                this.$store.dispatch(
                  "sysInit/changerTurnMicStartTitle",
                  this.$store.state.sysInit.temp_VoiceConnectionMode
                );
              }

              if (
                this.$store.state.sysInit.temp_VoiceConnectionMode !=
                "NEXMO_ASTERISK_PBX_MODE"
              ) {
                this.$store.dispatch(
                  "sysInit/changerTurnMicStartTitle",
                  this.$store.state.sysInit.temp_VoiceConnectionMode
                );
              }

              this.$store.dispatch("sysInit/connectStatusWs");
              this.$store.dispatch("stt/changeOnCallFlag");
              this.$store.dispatch("sysInit/getSttToken");
              Message.success({
                message:
                  this.$store.state.sysInit.html_const
                    .cons_258_personal_setting,
              });
              this.$store.state.sysInit.piIssueListEmptyFlg = true;
              this.$store.state.sysInit.piCustomerInfoEmptyFlg = true;
              this.$store.state.sysInit.manualChatbotShowFlg = true;
              this.$store.state.sysInit.searchDetail_unsolvedIssueListVisible = false;
              this.$store.state.sysInit.unsolvedIssueList = [];
              this.$store.state.sysInit.searchDetail_issue_tracker = ""
              this.$store.state.sysInit.searchDetail_issue_category = ""
               if (this.$store.state.sysInit.temp_VoiceConnectionMode == "MANUAL_CHAT_MODE") {
                   this.$store.dispatch("sysInit/connectChatPiSocket");
                   this.$store.state.sysInit.searchConsequence = [];
                   this.$store.state.sysInit.newUserInfoForm.phone_number = "";
                    this.$store.state.sysInit.newUserInfoForm.firstname = "";
                    this.$store.state.sysInit.newUserInfoForm.lastname = "";
                    this.$store.state.sysInit.newUserInfoForm.mail = "";
                    this.$store.state.sysInit.newUserInfoForm.sex = "";
                    this.$store.state.sysInit.newUserInfoForm.birthday = "";
                    this.$store.state.sysInit.newUserInfoForm.former_address = "";
                    this.$store.state.sysInit.newUserInfoForm.current_address = "";
                    this.$store.state.sysInit.newUserInfoForm.customer_name_yomi = "";
               }
                if (this.$store.state.sysInit.temp_VoiceConnectionMode == "NEXMO_ASTERISK_PBX_MODE") {
                   this.$store.dispatch("sysInit/connectPiWs");
                   this.$store.state.sysInit.searchConsequence=[];
                   this.$store.state.sysInit.newUserInfoForm.phone_number = "";
                    this.$store.state.sysInit.newUserInfoForm.firstname = "";
                    this.$store.state.sysInit.newUserInfoForm.lastname = "";
                    this.$store.state.sysInit.newUserInfoForm.mail = "";
                    this.$store.state.sysInit.newUserInfoForm.sex = "";
                    this.$store.state.sysInit.newUserInfoForm.birthday = "";
                    this.$store.state.sysInit.newUserInfoForm.former_address = "";
                    this.$store.state.sysInit.newUserInfoForm.current_address = "";
                    this.$store.state.sysInit.newUserInfoForm.customer_name_yomi = "";
               }
                if (this.$store.state.sysInit.temp_VoiceConnectionMode == "STAND_MIC_MODE") {
                   this.$store.dispatch("sysInit/connectF2FSvSocket");
               }
              //  if (this.$store.state.sysInit.temp_VoiceConnectionMode == "MANUAL_CHAT_MODE") {
              //      setTimeout(() => {
              //        window.location.reload();
              //     }, 1000);
              //  }else if(this.$store.state.sysInit.temp_VoiceConnectionMode == "NEXMO_ASTERISK_PBX_MODE"){
              //   setTimeout(() => {
              //        window.location.reload();
              //     }, 1000);
              //  }
            },
            (err) => {}
          )
          .catch((err) => {
            console.log(err);
          });
      }
    },



     submitUpload() {
      let formData = new FormData();

      formData.append("file", this.file);
      formData.append("enctype", "multipart/form-data");

      formData.append("user_name","user_"+this.$store.state.sysInit.user_id);
      formData.append("user_id",this.$store.state.sysInit.user_id);

        formData.forEach((value, key) => {
        console.log("key %s: value %s", key, value);

      });
        console.log("formDate",formData)
      api
        .settingUploadImage(formData)
        .then(result => {
          console.log(result);
          if(result.data != "fail"){

          if(this.$store.state.sysInit.ws_mode == 'STAND_MIC_MODE'){
             this.$store.state.sysInit.operator_logo_f2f = result.data.data;
          }else{
            this.$store.state.sysInit.operator_logo = result.data.data;
          }

          }
          this.isUpload = false;
          this.$refs.imageUpload.clearFiles();
        })
        .catch(err => {
          console.log(err);
        });




//   function uuid() {
//     var s = [];
//     var hexDigits = "0123456789abcdef";
//     for (var i = 0; i < 36; i++) {
//         s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
//     }
//     s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
//     s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
//     s[8] = s[13] = s[18] = s[23] = "-";

//     var uuid = s.join("");
//     return uuid;
// }

    },

   handleRemove(file, fileList) {
     this.isUpload = false;
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file)
      //  this.logo_img_url = file.url;
      // this.isUpload = true;
      // console.log(" this.logo_img_url", this.logo_img_url)

    },
    handleChange(file, fileList) {
      this.file = file.raw;
      this.logo_img_url = URL.createObjectURL(file.raw);
       this.isUpload = true;
      console.log("this.file",this.file)
    },
  },
  created() {},
  mounted() {
    Bus.$on("noiseCancelBk", (noiseCancelBk) => {
      this.noiseCancelBk = noiseCancelBk;
    });
    Bus.$on("noiseCancelSpeech", (noiseCancelSpeech) => {
      this.noiseCancelSpeech = noiseCancelSpeech;
    });
  },
};
</script>
<style lang="scss" scoped>
.setting-disbled {
  pointer-events: none;
  background: darkgray;
}

.user_logo{
  border-radius: 50%;
  width: 70px;
  height: 70px;
  margin-bottom: 5px;
}

.setting-image{
  margin-left: 55px;
  text-align: center;

}
</style>
